var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.0625C3.23223 2.0625 2.8125 2.48223 2.8125 3V15C2.8125 15.5178 3.23223 15.9375 3.75 15.9375H12.75C13.2678 15.9375 13.6875 15.5178 13.6875 15V13.5C13.6875 13.1894 13.9394 12.9375 14.25 12.9375C14.5606 12.9375 14.8125 13.1894 14.8125 13.5V15C14.8125 16.1391 13.8891 17.0625 12.75 17.0625H3.75C2.61092 17.0625 1.6875 16.1391 1.6875 15V3C1.6875 1.86092 2.61092 0.9375 3.75 0.9375H10.0145C10.573 0.9375 11.1077 1.16403 11.4962 1.56529L14.2317 4.39044C14.6042 4.77515 14.8125 5.28965 14.8125 5.82515V9.75C14.8125 10.0606 14.5606 10.3125 14.25 10.3125C13.9394 10.3125 13.6875 10.0606 13.6875 9.75V5.82515C13.6875 5.58175 13.5929 5.34788 13.4235 5.17301L10.688 2.34786C10.5114 2.16547 10.2683 2.0625 10.0145 2.0625H3.75Z",
    fill: "#CDCEC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 9.1875C7.93935 9.1875 7.6875 9.43935 7.6875 9.75V13.5C7.6875 13.8106 7.93935 14.0625 8.25 14.0625H15.75C16.0606 14.0625 16.3125 13.8106 16.3125 13.5V9.75C16.3125 9.43935 16.0606 9.1875 15.75 9.1875H8.25Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.a86b93e8.svg";
export { ForwardRef as ReactComponent };